import { SECURITY_ISSUES } from 'constants/securityIssues';

import { Tooltip } from 'shared/mui/Tooltip';
import { Typography } from 'shared/mui/Typography';
import { FunctionField, FunctionFieldProps } from 'shared/react-admin/Fields';
import { SecurityIssuesTypes } from 'types/embedded/securityIssues';

export const SecurityIssuesField: React.FC<Omit<FunctionFieldProps, 'render'>> = (props) => {
  return (
    <FunctionField
      render={(record: { securityIssues: SecurityIssuesTypes[]; [key: string]: any }) => {
        const securityIssue = SECURITY_ISSUES[record?.securityIssues[0]];
        const isOpenForAll = record?.securityIssues[0] === SecurityIssuesTypes.Open;
        return (
          <Tooltip arrow title={isOpenForAll ? 'Маска = 0 или IP адрес = 0.0.0.0' : ''}>
            <Typography
              color={securityIssue?.color}
              component="span"
              fontSize={14}
              noWrap
              sx={{ textDecoration: isOpenForAll ? 'underline' : 'none' }}
            >
              {securityIssue?.title}
            </Typography>
          </Tooltip>
        );
      }}
      {...props}
    />
  );
};
